import React, { useState, useEffect } from "react"
// 1. Import the useParams hook
import { useParams, useNavigate } from "react-router-dom"
import { registerWithToken } from "../api/apiClient" // Assuming this is in apiClient.js

const RegisterTokenPage = () => {
  // 2. Get the token from the URL
  const { token } = useParams()
  const navigate = useNavigate()

  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  // 3. Store the token in state
  const [registrationToken, setRegistrationToken] = useState("")
  useEffect(() => {
    if (token) {
      setRegistrationToken(token)
    }
  }, [token])

  const handleSubmit = async e => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setError("Passwords do not match.")
      return
    }
    if (!registrationToken) {
      setError("Invalid or missing registration token.")
      return
    }

    setError("")
    setSuccess("")
    setIsSubmitting(true)

    try {
      await registerWithToken({
        token: registrationToken,
        password: password,
        confirmPassword: confirmPassword,
      })

      setSuccess("Registration successful! Redirecting to login...")
      // Automatically redirect to login after 2 seconds
      setTimeout(() => {
        navigate("/login")
      }, 2000)
    } catch (error) {
      setError(
        error.message ||
          "Registration failed. The token may be invalid or expired."
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl">
      <h2 className="text-3xl font-bold mb-6 text-gray-800 text-center">
        Set Your Password
      </h2>

      {/* Token field (read-only) */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Registration Token
        </label>
        <input
          className="w-full p-3 bg-gray-100 border border-gray-300 rounded-lg text-gray-500"
          type="text"
          value={registrationToken}
          readOnly
        />
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            New Password
          </label>
          <input
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="New Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Confirm New Password
          </label>
          <input
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
            placeholder="Confirm New Password"
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        {success && <p className="text-green-500 text-sm mb-4">{success}</p>}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 transition disabled:bg-indigo-400"
        >
          {isSubmitting ? "Registering..." : "Complete Registration"}
        </button>
      </form>
    </div>
  )
}

export default RegisterTokenPage
